import { CRMSearchSortValue, IntegerSortToCRMSearch } from '../constants/SortValues';
import { DEAL_PROPERTIES, DEAL_SPLIT_PROPERTIES } from '../constants/CrmSearchConstants';
export const convertPaginationStateForApi = paginationState => {
  return {
    page: paginationState.pageIndex,
    pageSize: paginationState.pageSize
  };
};
export const convertSortStateForApi = (sortState, isDefaultSort) => {
  if (isDefaultSort) {
    return [{
      property: DEAL_PROPERTIES.IS_CLOSED_WON,
      order: CRMSearchSortValue.ASCENDING
    }, {
      order: IntegerSortToCRMSearch[sortState.direction],
      property: sortState.columnName
    }];
  }
  return [{
    order: IntegerSortToCRMSearch[sortState.direction],
    property: sortState.columnName
  }];
};
export const convertDealPropertiesForFrameworkDataTable = deals => deals.map(deal => {
  const properties = deal.properties || {};
  // Expected property format:
  /*
  {
    id: string; // not supplied by our endpoint
    name: string;
    value: any;
  }
  */

  const correctedProperties = Object.keys(properties).reduce((acc, propertyKey) => {
    return Object.assign({}, acc, {
      [propertyKey]: Object.assign({}, properties[propertyKey], {
        name: propertyKey
      })
    });
  }, {});
  return Object.assign({}, deal, {
    id: `${deal.dealId}`,
    properties: correctedProperties
  });
});
export const hasDealSplit = (deal, dealSplitsEnabled) => dealSplitsEnabled && deal.properties[DEAL_PROPERTIES.NUM_DEAL_SPLITS] && Number(deal.properties[DEAL_PROPERTIES.NUM_DEAL_SPLITS].value) > 1;
export const getDealSplitPercentageForDealRow = (row, dealSplitsEnabled) => {
  const isDealSplitPresent = hasDealSplit(row, !!dealSplitsEnabled);
  const dealSplitPercentProperty = row.dealSplit.properties[DEAL_SPLIT_PROPERTIES.HS_DEAL_SPLIT_PERCENTAGE];
  const dealSplitPercent = dealSplitPercentProperty && dealSplitPercentProperty.value || '1';
  return isDealSplitPresent ? parseFloat(dealSplitPercent) : undefined;
};
export const getDealSplitAmountForDealRow = (row, dealSplitsEnabled, amount) => {
  const dealSplitPercentage = getDealSplitPercentageForDealRow(row, dealSplitsEnabled);
  if (dealSplitPercentage && amount) {
    return dealSplitPercentage * amount;
  }
  return amount;
};
export const getUseForDealScoreValue = value => {
  const HIGH_SCORE_THRESHOLD = 70;
  const MID_SCORE_THRESHOLD = 50;
  if (value < MID_SCORE_THRESHOLD) {
    return 'low';
  }
  if (value >= MID_SCORE_THRESHOLD && value < HIGH_SCORE_THRESHOLD) {
    return 'mid';
  }
  return 'high';
};
export const haveSelectedColumnsBeenUpdated = (selectedColumns, savedColumns) => {
  if (!selectedColumns) {
    return false;
  }
  if (selectedColumns.length !== savedColumns.length) {
    return true;
  }
  return !selectedColumns.every((column, index) => column.value === savedColumns[index]);
};
export const updateSelectedDeals = (row, checked, selectedDeals) => {
  const dealId = Number(row.id);
  if (checked && selectedDeals) {
    if (selectedDeals.includes(dealId)) {
      return selectedDeals;
    }
    return [...selectedDeals, dealId];
  } else if (checked && !selectedDeals) {
    return [dealId];
  } else {
    var _selectedDeals$filter;
    return (_selectedDeals$filter = selectedDeals === null || selectedDeals === void 0 ? void 0 : selectedDeals.filter(id => id !== dealId)) !== null && _selectedDeals$filter !== void 0 ? _selectedDeals$filter : Array();
  }
};